import stringEntropy from 'fast-password-entropy'

import config from '@/services/config'

export default {
  getMessage: (field, args, data) => data.message,
  validate(value) {
    const entropy = stringEntropy(value)
    const ratio = entropy / config.minEntropy
    return {
      valid: entropy >= config.minEntropy,
      data: {
        message:
          ratio < 0.75
            ? 'Password is too weak'
            : ratio >= 0.75 && ratio < 1
            ? 'Almost there...'
            : ratio >= 1 && ratio < 1.5
            ? 'Strong'
            : 'Very strong'
      }
    }
  }
}
